import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Controller } from "react-hook-form";
import { Card, Flex, Box, Text, Button, Spinner } from "@radix-ui/themes";
import { createAcademicYear } from "../../services/school/academicYear/createAcademicYear";
import { CriarAcademicYearFormValidation } from "./CriarAcademicYearFormValidation";
import { AcademicYearType } from "../../types/AcademicYear";
import TextFieldComponent from "../../components/inputs/Textfield/TextfieldComponent";
import { routes } from "../../routes";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";


export const CreateAcademicYear = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();


  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<{ year: number }>({
    resolver: yupResolver(CriarAcademicYearFormValidation),
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldUseNativeValidation: false,
  });


  const mutation = useMutation({
    mutationFn: createAcademicYear,
    onSuccess: () => {
      toast.success("Ano letivo criado com sucesso!");
      queryClient.invalidateQueries("academicYears-pagination");
      navigate(routes.academicYears);
    },
    onError: (error: any) => {
      toast.error(error?.message ?? "Erro ao criar ano letivo");
    },
  });

  const onSubmit = handleSubmit(async (data) => {

    await mutation.mutate({ year: `${data.year}` });
  });


  return (
    <form onSubmit={onSubmit} noValidate>
      <Card size="1" className="max-w-md mx-auto p-4">
        <Flex direction='column' gap='4'>
          <TextFieldComponent name="year" label='Ano lectivo' control={control} errors={errors} fieldProps={{ placeholder: 'Ano Lectivo' }} required={true} />
          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button type="submit" disabled={mutation.isLoading} variant='surface'  >
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
};
